import { createSignal, createUniqueId, onMount, type JSX } from "solid-js";

export function Modal(props: { title: JSX.Element; onClose: () => void; children: JSX.Element }) {
  const [active, setActive] = createSignal(false);
  const titleId = createUniqueId();
  onMount(() => requestAnimationFrame(() => setActive(true)));

  const close = () => {
    setActive(false);
    window.setTimeout(props.onClose, 200);
  };

  return (
    <div class={`modal-overlay ${active() ? "active" : ""}`} onClick={(event) => event.target === event.currentTarget && close()}>
      <div class="modal" role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <div class="modal-header">
          <h3 id={titleId}>{props.title}</h3>
          <button class="modal-close" type="button" onClick={close} aria-label="Schließen">✕</button>
        </div>
        <div class="modal-body">{props.children}</div>
      </div>
    </div>
  );
}
